export class StorageUser {
  id: number;
  name: string;
  vatId: string;

  constructor(data?: any) {
    if (data) {
      Object.assign(this, data);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/StorageUser.ts